import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RelatorioDTO } from '../../../../dtos/relatorio-dto';
import { Filial } from '../../../../filial/filial';
import { FilialService } from '../../../../filial/filial.service';
import { Usuario } from '../../../../usuario/usuario';
import { UsuarioService } from '../../../../usuario/usuario.service';
import { ChaveValorStrInterface } from '../../../../util/chave-valor-str-interface';
import { Util } from '../../../../util/util';
import { CustomDateValidator } from '../../../../validators/custom-date-validator';
import { RelatorioConsultaService } from '../../relatorio-consulta.service';

@Component({
  selector: 'app-rel-marcacao-interna-consulta',
  templateUrl: './rel-marcacao-interna-consulta.component.html',
  styleUrls: ['./rel-marcacao-interna-consulta.component.css']
})
export class RelMarcacaoInternaConsultaComponent implements OnInit {

  formularioDeMarcacoesInternas: FormGroup;

  listaFiliais: Filial[];

  listaTipoAgrupamentoParaMarcacaoInterna: ChaveValorStrInterface[];

  listaDeFuncionarios: Usuario[];

  constructor(private relatorioService: RelatorioConsultaService,
    private filialService: FilialService,
    private usuarioService: UsuarioService,
    private formBuilder: FormBuilder) {

    this.formularioDeMarcacoesInternas = this.formBuilder.group({
      filial: ['', [Validators.required]],
      dataInicial: [''],
      dataFinal: [''],
      codTipoAgrupamento: ['0', [Validators.required]],
      funcionarios: ['', [Validators.required]],
    }, {
      validator: [CustomDateValidator('dataInicial'),
      CustomDateValidator('dataFinal')],
    });

    this.listaFiliais = [];

    this.listaTipoAgrupamentoParaMarcacaoInterna = Util.listaTipoAgrupamentoParaMarcacaoInterna;

    this.listaDeFuncionarios = [];
  }

  ngOnInit() {

    this.listarFiliais();

    this.listarFuncionarios();
  }

  onSubmit() {
    this.gerarRelatorio();
  }

  gerarRelatorio(): void {

    const relatorioDTO: RelatorioDTO = Object.assign(new RelatorioDTO(), this.formularioDeMarcacoesInternas.value);

    const funcionarios: Usuario[] = this.controlFuncionarios.value;
    const loginsFuncionarios: string[] = [];

    funcionarios.forEach((element) => {
      loginsFuncionarios.push(element.username);
    });

    relatorioDTO.idsStringArray = loginsFuncionarios;

    this.relatorioService.gerarRelatorioDeMarcacoesInternas(relatorioDTO)
      .subscribe((response: BlobPart) => {
        const file = new Blob([response], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      });
  }

  listarFiliais() {
    this.filialService.semRelacionamento()
      .subscribe(data => {
        // console.log(data)
        this.listaFiliais = data;

      }, error => {
        console.log(error);
      });
  }

  listarFuncionarios() {
    this.usuarioService.listarComProjecao()
      .subscribe(data => {
        // console.log(data)
        this.listaDeFuncionarios = data;

      }, error => {
        console.log(error);
      });
  }

  get controlFuncionarios() {

    return this.formularioDeMarcacoesInternas.controls.funcionarios;

  }

}
